export default __webpack_public_path__ + "static/media/Buildings_Hostel1.01546ecd.JPG";